import { Component, OnInit } from '@angular/core';
import { faHistory } from '@fortawesome/pro-solid-svg-icons';

@Component({
    selector: '[pcg-svg-history]',
    templateUrl: './svg-history.component.html',
    styleUrls: ['./svg-history.component.scss'],
    standalone: false
})
export class SvgHistoryComponent implements OnInit {

	faIconName = { faHistory }

	constructor() {}

	ngOnInit() {}
}